import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { RootState } from "@/store/modules/general/types";
import { FACTURA } from './types';

const namespaced = true;

type FacturasModule = Module<FACTURA, RootState>;

export const facturas: FacturasModule = {
    namespaced,
    actions,
    getters,
    mutations,
}